import React from 'react';
export interface IconProps {
  className?: string;
  strokeWidth?: number;
  'aria-hidden'?: boolean | 'true' | 'false';
}
export type IconComponent = React.ComponentType<IconProps>;

/**
 * Tiny hand-rolled icon set (24x24, stroke based) so the page ships no icon
 * library at all — every glyph below is only the few bytes it needs.
 */
function Svg({
  className = '',
  strokeWidth = 1.8,
  children,
  ...rest
}: IconProps & {
  children: React.ReactNode;
}) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} focusable="false" {...rest} data-id="element-105" data-mp="2jsmmmqf10wd2">
      {children}
    </svg>;
}
export function CheckIcon(props: IconProps) {
  return <Svg {...props} data-id="element-106" data-mp="d1dn2sq949e4">
      <path d="M4 12.5 9 17.5 20 6.5" data-id="element-107" data-mp="d0lt1mcayjpy" />
    </Svg>;
}
export function CheckCircle2Icon(props: IconProps) {
  return <Svg {...props} data-id="element-108" data-mp="856ip4di75ya">
      <circle cx="12" cy="12" r="9" data-id="element-109" data-mp="11e2vkzjace0b" />
      <path d="M8 12.5l2.5 2.5L16 9.5" data-id="element-110" data-mp="11d1a014n894c" />
    </Svg>;
}
export function XIcon(props: IconProps) {
  return <Svg {...props} data-id="element-111" data-mp="15ed0e8vccydl">
      <path d="M6 6l12 12M18 6L6 18" data-id="element-112" data-mp="15duzgyxqhvzc" />
    </Svg>;
}
export function PlusIcon(props: IconProps) {
  return <Svg {...props} data-id="element-113" data-mp="1acy2yey2fu57">
      <path d="M12 5v14M5 12h14" data-id="element-114" data-mp="1fdlt6yeh06yd" />
    </Svg>;
}
export function StarIcon(props: IconProps) {
  return <Svg {...props} data-id="element-115" data-mp="hqlqfbx9wxfh">
      <path d="M12 3.5l2.6 5.3 5.9.85-4.25 4.15 1 5.85L12 16.9l-5.25 2.75 1-5.85L3.5 9.65l5.9-.85z" data-id="element-116" data-mp="hr4v3qxwxpbk" />
    </Svg>;
}
export function ShoppingBagIcon(props: IconProps) {
  return <Svg {...props} data-id="element-117" data-mp="rnrfkembued2">
      <path d="M5 7h14l-1 13H6L5 7z" data-id="element-118" data-mp="rn86zoikh2bp" />
      <path d="M9 7a3 3 0 0 1 6 0" data-id="element-119" data-mp="rm6ox034vfkh" />
    </Svg>;
}
export function ShieldCheckIcon(props: IconProps) {
  return <Svg {...props} data-id="element-120" data-mp="3v4zv2rtl124m">
      <path d="M12 3l7 3v6c0 4.4-2.9 7.6-7 9-4.1-1.4-7-4.6-7-9V6l7-3z" data-id="element-121" data-mp="3v5hyc8enwgm1" />
      <path d="M9 12.2l2.2 2.2L15.5 10" data-id="element-122" data-mp="3yp1thutd5nu" />
    </Svg>;
}
export function FootprintsIcon(props: IconProps) {
  return <Svg {...props} data-id="element-123" data-mp="3s2vd2n82t3zt">
      <path d="M4 19h4v-4h4v-4h4V7h4" data-id="element-124" data-mp="3s2bxhd5weroy" />
    </Svg>;
}
export function Rows3Icon(props: IconProps) {
  return <Svg {...props} data-id="element-125" data-mp="3o1a6tkq1rnyl">
      <path d="M3 8h18M6 8v11M18 8v11" data-id="element-126" data-mp="3nzp9xog9fsxk" />
    </Svg>;
}
export function ScaleIcon(props: IconProps) {
  return <Svg {...props} data-id="element-127" data-mp="5pn7j4relmrb">
      <path d="M12 3.5v17M5 8.5l7-3 7 3M7 20h10" data-id="element-128" data-mp="o7iz2q0oy46" />
    </Svg>;
}
export function MoveDiagonalIcon(props: IconProps) {
  return <Svg {...props} data-id="element-129" data-mp="395aq5lovgfhu">
      <path d="M5 19L19 5" data-id="element-130" data-mp="394svgthuy9c1" />
      <path d="M13.5 5H19v5.5" data-id="element-131" data-mp="352xmd2toqrnp" />
    </Svg>;
}
export function ZapIcon(props: IconProps) {
  return <Svg {...props} data-id="element-132" data-mp="3j2fe9r2a2l1a">
      <path d="M6 13.5l6-6 6 6" data-id="element-133" data-mp="3j2yvf5k3t5e9" />
      <path d="M6 19.5l6-6 6 6" data-id="element-134" data-mp="3j408ffkok1ym" />
    </Svg>;
}
export function ClipboardListIcon(props: IconProps) {
  return <Svg {...props} data-id="element-135" data-mp="3e5ozd727lvhg">
      <path d="M9 4.5h6v3H9z" data-id="element-136" data-mp="ychovssxc60k" />
      <path d="M15 6h3v14H6V6h3" data-id="element-137" data-mp="ybex7ins1zjl" />
      <path d="M9.5 11h5M9.5 15h5" data-id="element-138" data-mp="yan2sb5x27uw" />
    </Svg>;
}